import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { Button } from 'ustore-ui';

import { I18nPipe } from '../../shared/pipes/i18n.pipe';

@Component({
  selector: 'umkt-order-error',
  standalone: true,
  imports: [CommonModule, RouterModule, Button, I18nPipe],
  templateUrl: './order-error.component.html',
  styleUrls: ['./order-error.component.scss']
})
export class OrderErrorComponent {
  currentYear = new Date().getFullYear();
  private router = inject(Router);


  goToCheckout(): void {
    this.router.navigate(['/checkout']);
  }

  goToHome(): void {
    this.router.navigate(['/']);
  }
}

